import { agileSuccess } from './agileHelper';
import { ajaxCall } from './ajax';

export function agileFormYellowBanner() {
    return {
        fields: [
            {
                name: 'full_name',
                label: 'Je naam',
                value: '',
                error: '',
            },
            {
                name: 'company_name',
                label: 'Je bedrijfsnaam',
                value: '',
                error: '',
            },
            {
                name: 'email_address',
                label: 'Je e-mailadres',
                value: '',
                error: '',
            },
        ],

        instalatieBedrijf: false,

        action: 'agileFormYellowBanner',
        dialog: '',
        valid: false,
        loading: false,
        success: false,
        tags: [],

        async submitData() {
            this.dialog = '';
            this.valid = true;
            this.loading = true;
            this.fields.forEach((field, i) => (this.fields[i].error = ''));
            await this.attemptSend();
            this.loading = false;
        },

        async attemptSend() {
            // client side check
            this.fields.forEach((field, i) => {
                if (field.value === '') {
                    this.valid = false;
                    this.fields[i].error = 'Dit veld is verplicht';
                    this.dialog = 'Een of meerdere velden moeten nog ingevuld worden';
                }
            });

            if (!this.valid) {
                this.loading = false;
                return;
            }

            if (this.instalatieBedrijf) {
                this.tags.push('Installatiebedrijf');
            }

            let data = { tags: this.tags };
            this.fields.forEach((field) => (data[field.name] = field.value));

            let { data: responseData } = await ajaxCall(this.action, data);

            if (responseData.success) {
                // this.dialog = "Bedankt voor uw interesse";
                this.success = true;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'nieuwsbrief' });

                if (typeof _agile !== 'undefined') {
                    _agile.set_email(
                        this.fields[this.fields.findIndex((field) => field.name === 'email_address')].value
                    );
                }

                agileSuccess({
                    email: this.fields[this.fields.findIndex((field) => field.name === 'email_address')].value,
                });
            } else {
                this.dialog = responseData.data.dialog;

                for (var [key, errorMessage] of Object.entries(responseData.data.errors)) {
                    let errorKey = this.fields.findIndex((field) => key === field.name);
                    this.fields[errorKey].error = errorMessage;
                }
            }
        },
    };
}
